import React, { useState, useEffect } from 'react';

const STYLES = {
  error:   { bg: '#fef2f2', border: '#fca5a5', text: '#dc2626', icon: '✕' },
  success: { bg: '#f0fdf4', border: '#86efac', text: '#16a34a', icon: '✓' },
  warning: { bg: '#fffbeb', border: '#fcd34d', text: '#d97706', icon: '⚠' },
  info:    { bg: '#eff6ff', border: '#93c5fd', text: '#2563eb', icon: 'ℹ' },
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handle = (e) => {
      const t = e.detail;
      setToasts(prev => [...prev, t]);
      setTimeout(() => setToasts(prev => prev.filter(x => x.id !== t.id)), 4500);
    };
    window.addEventListener('app:toast', handle);
    return () => window.removeEventListener('app:toast', handle);
  }, []);

  if (!toasts.length) return null;

  return (
    <>
      <style>{`
        @keyframes toastIn {
          from { opacity: 0; transform: translateX(40px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes toastOut {
          from { opacity: 1; }
          to   { opacity: 0; }
        }
      `}</style>
      <div style={{
        position: 'fixed', top: 24, right: 24, zIndex: 999999,
        display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 380, pointerEvents: 'none',
      }}>
        {toasts.map(t => {
          const c = STYLES[t.type] || STYLES.error;
          return (
            <div
              key={t.id}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: 10,
                padding: '12px 14px',
                background: c.bg,
                border: `1px solid ${c.border}`,
                borderRadius: 10,
                boxShadow: '0 6px 24px rgba(0,0,0,0.13)',
                animation: 'toastIn .22s ease',
                fontSize: 13.5, color: c.text, fontWeight: 500, lineHeight: 1.45,
                minWidth: 220, maxWidth: 380,
                pointerEvents: 'all',
              }}
            >
              <span style={{ fontWeight: 800, fontSize: 14, flexShrink: 0, marginTop: 2 }}>{c.icon}</span>
              <span style={{ flex: 1 }}>{t.message}</span>
              <button
                onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 0 6px', color: c.text, fontSize: 18, lineHeight: 1, opacity: 0.55, flexShrink: 0, fontWeight: 400 }}
              >×</button>
            </div>
          );
        })}
      </div>
    </>
  );
}
